import "@stone-payments/jade-design-tokens/stone-rebrand/fonts.css";
import "@stone-payments/jade-design-tokens/stone-rebrand/typography.css";
import "@stone-payments/jade-design-tokens/stone-rebrand/space.css";

import { ThemeColorsServer } from "./theme-colors-server";
import { ThemeColorsClient } from "./theme-colors-client";

import { Theme } from "@/types/general";

type Props = {
  theme: Theme;
};

export const ThemeColors = ({ theme }: Props) => {
  return typeof window === "undefined" ? (
    <ThemeColorsServer theme={theme} />
  ) : (
    <ThemeColorsClient theme={theme} />
  );
};
